import { observer } from 'mobx-react-lite';
import { FrPage } from '../fr-page-layout/fr-page';
import { FrBoloPageHeader } from './components/fr-bolo-page-header';
import { FrBoloPageFooter } from './components/fr-bolo-page-footer';
import { FrBoloPageBody } from './components/fr-bolo-page-body';

export const FrBoloPage = observer(() => {
    return (
        <FrPage>
            <FrBoloPageHeader />
            <FrBoloPageBody />
            <FrBoloPageFooter />
        </FrPage>
    );
});
